import { render, staticRenderFns } from "./AppDataTableTop.vue?vue&type=template&id=32a4155c&scoped=true&"
import script from "./AppDataTableTop.vue?vue&type=script&lang=js&"
export * from "./AppDataTableTop.vue?vue&type=script&lang=js&"
import style0 from "./AppDataTableTop.vue?vue&type=style&index=0&id=32a4155c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a4155c",
  null
  
)

export default component.exports